import React, { Suspense, lazy, useState } from 'react';
import { Trans } from 'react-i18next';

import classNames from 'classnames';

import SidemenuShareIcon from 'icons/share-icon.svg';

import './SideShareMenu.scss';

const SideShareMenuList = lazy(() => import('./SideShareMenuList'));

interface Props {
  preText?: string;
  containerClass?: string;
}

export const SideShareMenu = ({ preText, containerClass = 'blog-share-menu' }: Props) => {
  const [open, setOpen] = useState(false);

  return (
    <div className={classNames('share-menu-wrapper', containerClass)}>
      <button
        className={open ? 'share-menu-link open' : 'share-menu-link'}
        type="button"
        aria-label="Share"
        onClick={() => setOpen(!open)}
      >
        <SidemenuShareIcon />
        <span className="share-menu-text">
          <Trans>Share</Trans>
        </span>
      </button>
      {open && (
        <Suspense>
          <SideShareMenuList preText={preText} />
        </Suspense>
      )}
    </div>
  );
};
